export default __webpack_public_path__ + "static/media/pickup.1f6f23fa.svg";